import React from 'react'
import PurchaseConfirmSummary from './PurchaseConfirmSummary'

export default function BufferPurchaseSummary() {
    return (
        < div>
            <PurchaseConfirmSummary xState={'RECEIVED'} />
        </div>
    )
}
